import { render } from "./ImgView.vue?vue&type=template&id=0aa6f7a4&scoped=true"
import script from "./ImgView.vue?vue&type=script&lang=js"
export * from "./ImgView.vue?vue&type=script&lang=js"

import "./ImgView.vue?vue&type=style&index=0&id=0aa6f7a4&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa6f7a4"]])

export default __exports__